export const bucketClientCountText = (count: number): string => {
  if (count === 0) return 'No clients currently in this bucket.';
  return count === 1 ? '1 client currently in this bucket.' : `${count} clients currently in this bucket.`;
};
